import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cscProductPreview = {
  columnGap: css`var(--csc-product-preview-column-gap, ${csSpacing.spacing06})`,
  rowGap: css`var(--csc-product-preview-row-gap, ${csSpacing.spacing04})`
}

export const style = css`
  :host {
    --cse-link-secondary-color: var(--cs-font-product-title-m-color);
  }

  .csc-product-preview {
    --cse-list-gap: ${cscProductPreview.rowGap};

    display: flex;
    column-gap: ${cscProductPreview.columnGap};
  }

  .csc-product-preview > cse-list {
    min-width: 0;
  }

  cse-list-item cse-text {
    min-width: 0;
  }

  cse-list-item:first-child cse-text {
    --cse-text-overflow: var(--csc-product-preview-title-overflow, visible);
    --cse-text-white-space: var(--csc-product-preview-title-white-space, normal);
    --cse-text-text-overflow: var(--csc-product-preview-title-text-overflow, clip);
  }

  cse-list-item:first-child cse-link {
    min-width: 0;
    max-width: 100%;
  }

  .csc-product-preview__title--clamped {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: var(--csc-product-preview-title-line-clamp);
    overflow: hidden;
    overflow-wrap: anywhere;
  }
`
